// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"9a097990","263":"744da361","319":"d5122281","465":"9a097990","504":"2d69b442","836":"4e3b09fa"}[chunkId] + ".chunk.css";
};